// Error HTTP con status: el backend usa los status como respuesta de negocio
// (400 sin dias, 404 legajo invalido, 422 solapamiento), asi que los services
// los traducen a mensajes en vez de tratarlos como fallas.
export class ApiError extends Error {
  constructor(status, body = null) {
    super("HTTP " + status);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}
